import script from "./add-branches.vue?vue&type=script&setup=true&lang=js"
export * from "./add-branches.vue?vue&type=script&setup=true&lang=js"

import "./add-branches.vue?vue&type=style&index=0&id=6ea9b34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea9b34c"]])

export default __exports__